import React from 'react';
import Resources from '../pages/Resources';
import '../css/Contribution.css';
import GoToTopButton from '../pages/GoToTopButton';
import ScrollProgressBar from 'react-scroll-progress-bar';
const Contribution = () => {
  return (
    <div className="contribution-container">
      <Resources />
      <iframe
        src="https://docs.google.com/document/d/e/2PACX-1vS9MYL1xSM3AmdUP6W6O8aiVow1obzM3NeQssiJ_ypxK3IfrTHjktXRVNQ8B2WZ6ipshKajHMvI79oC/pub?embedded=true"
        width="1000"
        height="auto"
        className="contribution-iframe"
      ></iframe>
        <GoToTopButton />
        <ScrollProgressBar height="4px" color="#007bff" duration="0.2" />
        
    </div>
  );
};

export default Contribution;
